/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Spinner from '@atlaskit/spinner';
export var Loader = function Loader() {
  return jsx("div", {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css: css({
      textAlign: 'center',
      paddingTop: "var(--ds-space-150, 12px)",
      paddingBottom: "var(--ds-space-150, 12px)",
      width: '100%',
      overflow: 'hidden'
    })
  }, jsx(Spinner, {
    testId: "forge-app-loading-spinner",
    size: "large"
  }));
};